import { InputField } from '@components/form/input-field/InputField';
import { useTranslation } from 'react-i18next';

export const AnnouncementFormDisabledStoryLinkInput = () => {
  const { t } = useTranslation(['mailings']);

  const handler = () => {
    return Promise.resolve();
  };

  return (
    <InputField
      disabled
      autoComplete="off"
      data-test="story-link-input"
      id="story-link-input"
      name="storyLink"
      placeholder={t(
        'mailings:personalizedMailingCreatorWizard.objectivesForm.announcement.storyLink.placeholder',
      )}
      size="l"
      value={''}
      onBlur={handler}
      onChange={handler}
    />
  );
};
